import { render } from "./PersonalDataSection.vue?vue&type=template&id=623ae803&scoped=true"
import script from "./PersonalDataSection.vue?vue&type=script&lang=js"
export * from "./PersonalDataSection.vue?vue&type=script&lang=js"

import "./PersonalDataSection.vue?vue&type=style&index=0&id=623ae803&scoped=true&lang=css"

import exportComponent from "../../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623ae803"]])

export default __exports__